import { get } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchAchievements = (): Promise<AxiosResponse> =>
  get('/achievements/achievements', {
    include: 'imageMedia,userAchievement',
    sort: '-user_achievement,user_achievements_count',
    'filter[status]': 'active',
  })

export const fetchUserState = (id: string): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/user-state`)

export const fetchCoursesList = (): Promise<AxiosResponse> =>
  get('/courses/courses')
